import { useState, useEffect } from 'react';
import { authApi } from '../services/auth.service';
import { tenantConfig } from '../lib/tenant';

export default function ResetPasswordPage() {
  const [token, setToken] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    setToken(params.get('token') ?? '');
  }, []);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');

    if (newPassword !== confirm) {
      setError('As senhas não coincidem');
      return;
    }

    setLoading(true);
    try {
      await authApi.resetPassword(token, newPassword);
      setSuccess(true);
    } catch (err: any) {
      setError(err.response?.data?.message || 'Token inválido ou expirado');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-100 to-slate-50 flex items-center justify-center p-4">
      <div className="w-full max-w-md bg-white rounded-lg shadow-lg border border-slate-200">
        <div className="text-center p-6 border-b border-slate-200">
          <div className="flex justify-center mb-3">
            {tenantConfig.logoUrl ? (
              <img src={tenantConfig.logoUrl} alt={tenantConfig.appName} className="h-12" />
            ) : (
              <span className="text-2xl font-bold text-slate-800">{tenantConfig.appName}</span>
            )}
          </div>
          <p className="text-sm text-slate-600">Criar nova senha</p>
        </div>

        <div className="p-6">
          {success ? (
            <div className="text-center space-y-4">
              <div className="bg-green-50 text-green-700 border border-green-200 px-4 py-3 rounded-lg text-sm">
                Senha redefinida com sucesso!
              </div>
              <a
                href="/"
                className="inline-block text-sm text-slate-600 hover:text-slate-900 underline"
              >
                Ir para o login
              </a>
            </div>
          ) : (
            <>
              {error && (
                <div className="bg-red-50 text-red-600 border border-red-200 px-4 py-3 rounded-lg mb-4 text-sm">
                  {error}
                </div>
              )}

              {!token && (
                <div className="bg-yellow-50 text-yellow-700 border border-yellow-200 px-4 py-3 rounded-lg mb-4 text-sm">
                  Link inválido. Solicite um novo email de recuperação.
                </div>
              )}

              <form onSubmit={handleSubmit} className="space-y-4">
                <div className="space-y-2">
                  <label htmlFor="new-password" className="text-sm font-medium text-slate-700 block">
                    Nova senha
                  </label>
                  <input
                    id="new-password"
                    type="password"
                    value={newPassword}
                    onChange={(e) => setNewPassword(e.target.value)}
                    placeholder="••••••••"
                    required
                    minLength={6}
                    disabled={!token}
                    className="w-full px-3 py-2 border border-slate-300 rounded-md focus:outline-none focus:ring-2 focus:ring-slate-400 focus:border-transparent disabled:opacity-50"
                  />
                </div>
                <div className="space-y-2">
                  <label htmlFor="confirm-password" className="text-sm font-medium text-slate-700 block">
                    Confirmar nova senha
                  </label>
                  <input
                    id="confirm-password"
                    type="password"
                    value={confirm}
                    onChange={(e) => setConfirm(e.target.value)}
                    placeholder="••••••••"
                    required
                    minLength={6}
                    disabled={!token}
                    className="w-full px-3 py-2 border border-slate-300 rounded-md focus:outline-none focus:ring-2 focus:ring-slate-400 focus:border-transparent disabled:opacity-50"
                  />
                </div>
                <button
                  type="submit"
                  disabled={loading || !token}
                  className="w-full bg-slate-900 hover:bg-slate-800 text-white font-medium py-2 px-4 rounded-md transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
                >
                  {loading ? 'Salvando...' : 'Salvar nova senha'}
                </button>
              </form>

              <div className="mt-6 text-center">
                <a href="/" className="text-sm text-slate-600 hover:text-slate-900 underline">
                  Voltar para o login
                </a>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
